export const TOKEN = process.env.TOKEN || 'OGY'
